import { JiraLogo } from "@atlaskit/logo";

import AccountCreation from "@/components/signup/account-creation";
import { SignupBackgroundLayout } from "@/components/signup/layouts";
import { FeatureExposed } from "@/utils/feature-exposed";

import { GetStartedHeading } from "./components/get-started-heading";
import { Jfind1249SubHeading } from "./components/jfind-1249-subheading";
import { InputSubmitButton } from "./components/submit-input";

export const LoggedOutJiraFree = () => {
    return (
        <SignupBackgroundLayout
            ProductLogo={<JiraLogo size="xlarge" appearance="brand" />}
        >
            <GetStartedHeading />
            <Jfind1249SubHeading />
            <FeatureExposed
                experimentKey="jfind-1185-signup-button-update"
                group="Test"
            >
                <AccountCreation Input={<InputSubmitButton />} Submit={null} />
            </FeatureExposed>
        </SignupBackgroundLayout>
    );
};
